export default "__VITE_ASSET__BSfQOPVi__"